import React, { useState, useEffect, useContext } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import { SessionContext } from "../context/session-context";

import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';

import GetAppIcon from '@material-ui/icons/GetApp';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import AutorenewIcon from '@material-ui/icons/Autorenew';

const useStyles = makeStyles({
    orderItem: {
        padding: 10,
        border: '1px solid #D2D2D8',
        width: '98%',
        marginBottom: 5,
        '& .MuiOutlinedInput-root':{
            height:30
        },
        color: '#000',
    },
    productLabel:{
        marginBottom: 10,
    },
    productFormat:{
        minWidth: 100
    },
    textItemFont:{
        fontSize:11
    },
    productSelectButton: {
        marginLeft: 20,
        marginTop: 5,
    },
    downloadIcon: {
        width: 16,
        height: 16
    },
    downloadButton: {
        marginTop: 4,
        height: 28,
        width: 90,
        backgroundColor:'#29C548',
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#E55300'
        },
        marginRight: 4,
      },
      textField:{
        width: 200,
      },
      textItemFont:{
        fontSize:11
      }
});

const handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
};

export default function OrderItemCard(props) {
  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [action, setAction] = useState([]);
  const [products, setProducts] = useState([]);
  const [orderid, setOrderid] = useState(props.item.orderid);
  const [userid, setUserid] = useState(sState.userid);
  const [status, setStatus] = useState(props.item.status);

  const [severity, setSeverity] = useState('success');
  const [msg, setMsg] = useState('');
  const [snackOpen, setSnackOpen] = useState(false);

  useEffect(() => { 

    setAction(props.item.ordertype.charAt(0).toUpperCase() + props.item.ordertype.slice(1));

    let productarray = props.item.products.replace("{","");
    productarray = productarray.replace("}","");
    productarray = productarray.replace(/"/g,"");
    const parray = productarray.split(",");
    let display =[];
    parray.forEach(function (item) {
      let i = item.split("-");
      let label = i[0];
      let format = '';
      if (props.item.ordertype !== 'print') { format = " ("+i[1]+")"; }
      display.push(label+format);
    });
    setProducts(display);
  },[props.item.products])

  const handleDownloadClick = () => {
        props.handleClick(props.item.orderid);
  }

const handleOrderChange = () => {

    let orderStatus = '';
    let orderReason = '';
    switch(status){
        case "completed":
            orderStatus = 'completed';
            orderReason = '';
            break;
        case "ordered":
            orderStatus = 'ordered';
            orderReason = '';
            break;
        case "processing":
            orderStatus = 'processing';
            orderReason = '';
            break;
        case "void":
        case "void, duplicate":
            orderStatus = 'void';
            orderReason = 'Order has been duplicated';
            break;
        case "void, failed":
            orderStatus = 'void';
            orderReason = 'Order failed to complete';
            break;
        case "void, mistake":
            orderStatus = 'void';
            orderReason = 'Order created by mistake';
            break;
    }
    saveOrderStatusChange(orderStatus, orderReason);
}

    const saveOrderStatusChange = (s, n) => {

        const abortController = new AbortController();

        const request = {   
            orderid: orderid,
            userid: userid,
            status: s,
            notes: n,
        };

        let mounted = true;
        (async () => {  
            const res = await fetch(process.env.REACT_APP_FIND_API+'/find/order/update', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(request),
            signal: abortController.signal,
            }).catch(handleError);
            const data = await res.json();
            if (mounted) {
                if (data.status === "success"){
                    //props
                    setSeverity('success')
                    setMsg('Order has been updated.')
                    setSnackOpen(true);
                } else {
                    setSeverity('error')
                    setMsg('Failed to update order.')
                    setSnackOpen(true);
                }
            }
            const cleanup = () => {
                mounted = false;
                abortController.abort();
            };
            return cleanup;
        
        })();
    }

    const reorderItem = (s, n) => {

        const abortController = new AbortController();

        const request = {   
            orderid: orderid,
            userid: userid,
            status: s,
            notes: n,
        };

        let mounted = true;
        (async () => {  
            const res = await fetch(process.env.REACT_APP_FIND_API+'/find/order/update', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(request),
            signal: abortController.signal,
            }).catch(handleError);
            const data = await res.json();
            if (mounted) {
                if (data.status === "success"){
                    //props
                    setSeverity('success')
                    setMsg('Order has been updated.')
                    setSnackOpen(true);
                } else {
                    setSeverity('error')
                    setMsg('Failed to update order.')
                    setSnackOpen(true);
                }
            }
            const cleanup = () => {
                mounted = false;
                abortController.abort();
            };
            return cleanup;
        
        })();
    }

    const handleSnackClose=()=>{
        setSnackOpen(false);
    }

  return (
    <div className={classes.orderItem}>

        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackOpen}
            autoHideDuration={6000}
            onClose={handleSnackClose}
            TransitionComponent={Slide}
            TransitionProps={{ direction: 'down' }}
        >
            <Alert onClose={handleSnackClose} severity={severity}>
            {msg}
            </Alert>
        </Snackbar>
        <Grid container>
            <Grid item xs={9} md={9}>
                <Grid container>
                    <Grid item xs={4} md={4}><Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={14} >Order Placed: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={14} >{props.item.orderdate}</Box></Box></Grid>
                    <Grid item xs={5} md={5}><Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={14} >Order By: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={14} >{props.item.username}</Box></Box></Grid>
                    <Grid item xs={3} md={3}><Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={14} >Order #: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={14} >{props.item.orderid}</Box></Box></Grid>
                    <Grid item xs={4} md={4}>
                        <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >Project Reference: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >{props.item.projectname}</Box></Box>
                        <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >PO Number:&nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >{props.item.userref}</Box></Box> 
                        <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >Action: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >{action}</Box></Box>
                    </Grid>
                    <Grid item xs={5} md={5}>
                        <Box fontWeight="fontWeightBold" fontSize={12} >Product items:</Box>
                        {products.map((item, i) =>
                            <Box key={i} fontWeight="fontWeightRegular" fontSize={12} >{item}</Box>  
                        )}
                    </Grid>
                    <Grid item xs={3} md={3}>
                        <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >Net: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >&nbsp;&nbsp;£{props.item.price}</Box></Box>
                        <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >VAT: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >&nbsp;&nbsp;£{props.item.vat}</Box></Box>
                        <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >Total: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >£{props.item.total}</Box></Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={3} md={3}>
                <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} defaultValue="processing" name="status" label="Item Status" size="small" margin="dense" variant="outlined" value={status} onChange={e => setStatus(e.target.value)} select>
                    <MenuItem value={'completed'}>Completed</MenuItem>
                    <MenuItem value={'ordered'}>Ordered</MenuItem>
                    <MenuItem value={'processing'}>Processing</MenuItem>
                    <MenuItem value={'void'}>Voided</MenuItem>
                    <MenuItem value={'void, duplicate'}>Void - Duplicate</MenuItem>
                    <MenuItem value={'void, failed'}>Void - Order failed</MenuItem>
                    <MenuItem value={'void, mistake'}>Void - Mistake</MenuItem>
                </TextField> 
                <Button className={classes.downloadButton} variant="contained" onClick={handleOrderChange}>
                    <Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Edit</Box>
                </Button>
                <Button className={classes.downloadButton} variant="contained">
                    <Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Reorder</Box>
                </Button>
            </Grid>
        </Grid>
    </div>

  );
}